// extracted by mini-css-extract-plugin
module.exports = {"textElement":"TextElement_textElement__20cna","isEnabled":"TextElement_isEnabled__2lNcp","primary":"TextElement_primary__1T2GI","secondary":"TextElement_secondary__2vHO1"};